const DEFAULT_I18NEXT_NAMESPACE = 'translation';
const DEFAULT_LOCALE = 'en';

export default {
  DEFAULT_I18NEXT_NAMESPACE,
  DEFAULT_LOCALE,
};
